
Greenmile.Survey = Greenmile.Survey || {};

Greenmile.Survey.UploadModal = function () {

    this.el;
    this.selector = "#Survey";
    this.options = {
        width: 600,
        height: 440
    };
    this.container = null;
    this.surveyId = null;

    this.setSurveyId = function (surveyId) {
        this.surveyId = surveyId;
    };

    this.showGenerateWindow = function () {
        this.clear();
        var modal = new Greenmile.Survey.ReportWindow();
        modal.surveyId = this.surveyId;
        modal.showModalForm();
    };

    this.showUploadWindow = function () {
        this.clear();

        var modal = new Greenmile.Survey.UploadWindow();
        modal.surveyId = this.surveyId;
        modal.showModalForm();
    };
    this.clear = function () {
        if (this.container) {
            this.container.innerHTML = "";
        }
    };

    this.goToHelp = function (label, key) {
        var helper = new Monet.UI.Help(label, Monet.I18n.getResourcesByKey(key));
        helper.render();
        helper.logIn();
    };

    this.goToLearnHelp = function () {
        this.goToHelp('SurveyReportLearn', "suvery.report.learn");
    };

    this.links = [
        { text: "suvery.report.learn", action: this.goToLearnHelp },
        { text: "suvery.report.generate", action: this.showGenerateWindow },
        { text: "suvery.report.upload", action: this.showUploadWindow }
    ];

    this.linkNodes = function () {
        return this.links.map(function (link) {
            var a = document.createElement("a");
            a.innerHTML = Monet.I18n.getResourcesByKey(link.text);
            a.addEventListener("click", link.action.bind(this));
            return a;
        }.bind(this));
    };

    this.renderEl = function () {
        this.container = document.querySelector(this.selector + " .popupFormContainer");
        this.clear();
        var div   = document.createElement("div"),
            info  = document.createElement("p"),
            ul    = document.createElement("ul"),
            links = this.linkNodes();

        info.innerHTML = Monet.I18n.getResourcesByKey("survey.reports.info");

        links.forEach(function (item) {
            var li = document.createElement("li");
            li.appendChild(item);
            ul.appendChild(li);
        });

        div.className = "SurveyUploadModel";
        div.appendChild(info);
        div.appendChild(ul);

        this.el = div;
        this.container.appendChild(this.el);
    };

    if (!this.callbacks) {
        this.callbacks = {
            onAfterShowModalForm: this.renderEl.bind(this)
        };
    }
};

Greenmile.Survey.UploadModal.prototype = new Monet.Form.Modal;
